import { Breadcrumb } from "ant-design-vue";
import "./src/breadcrumb.less"
const { Item, ...other } = Breadcrumb;
const YwBreadcrumb = {
	...other,
	name: "YwBreadcrumb",
	Item: {
		...Item,
		name: "YwBreadcrumbItem",
	},
};
YwBreadcrumb.install = function (Vue) {
	Vue.component(YwBreadcrumb.name, Breadcrumb);
	Vue.component(YwBreadcrumb.Item.name, Breadcrumb.Item);
};

// const NewMenu = {
// 	...other,
// 	...YwMenu,
// };

export default YwBreadcrumb;
